import postMessageToParentExtension from '../utils/postMessageToParentExtension';
import { MessageRequestTypes } from '../schema/RequestMessageTypes';

export const requestExtensionForMailBootData = (): void =>
    postMessageToParentExtension({ type: MessageRequestTypes.MailStartupData });
